<template>
  <div class="content">
    <div class="container-fluid p-0 col-10">
      <card>
        <h4 slot="header" class="card-title">Nová pojistná událost - hlášení majetku</h4>
        <form>
            <!-- Škodu hlásí -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-0" role="tab">
                    <b-button block v-b-toggle.documentsAcordion class="comfortLiquidityAcordion">
                        <span class="float-left pl-2">
                            Škodu hlásí
                        </span>
                        <span class="arrow-opened float-right">
                            <vue-fontawesome icon="chevron-down" />
                        </span>
                        <span class="arrow-closed float-right">
                            <vue-fontawesome icon="chevron-right" />
                        </span>
                    </b-button>
                </b-card-header>
                <b-collapse id="documentsAcordion" visible role="tabpanel">
                    <b-card-body class="reportDamagesCardContent">
                        <div class="row">
                            <div class="col-12 mb-3">
                                <div class="row">
                                    <div class="col-12">
                                        <select class="form-control" id="reportDamages" v-model="insuranceEventAssetObject.reportDamageTypeId" @change="reportDamageChange">
                                            <option v-for="reportDamage in reportDamages" :value="reportDamage.Id" :key="reportDamage.Id">
                                                {{reportDamage.Name}}
                                            </option>
                                        </select>
                                        <div v-if="reportDamageSubmitted && !insuranceEventAssetObject.reportDamageTypeId" class="invalid-feedback d-block">Pole není vyplněno</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="insuranceEventAssetObject.reportDamageTypeId === 3">
                            <div class="col-12">
                                <label for="otherPerson">Jiná pověřená osoba - typ</label>
                                <select class="form-control" id="otherPerson" v-model="insuranceEventAssetObject.otherAuthorizedPersonTypeId">
                                    <option v-for="otherPersonType in otherPersonTypes" :value="otherPersonType.Id" :key="otherPersonType.Id">
                                        {{otherPersonType.Name}}
                                    </option>
                                </select>
                                <div v-if="reportDamageSubmitted && !insuranceEventAssetObject.otherAuthorizedPersonTypeId && insuranceEventAssetObject.reportDamageTypeId === 3"
                                    class="invalid-feedback d-block">Pole není vyplněno</div>
                            </div>
                        </div>
                        <b-button variant="primary" class="float-right mb-3" @click="reportDamageNext()">Další</b-button>
                    </b-card-body>
                </b-collapse>
            </b-card>

            <!-- Poškozený -->
            <b-card no-body class="mb-1" v-show="insuranceEventAssetObject.reportDamageTypeId !== -1 && damagedShow">
                <b-card-header header-tag="header" class="p-0" role="tab">
                    <b-button block v-b-toggle.reportDamagesAccordion class="comfortLiquidityAcordion">
                        <span class="float-left pl-2">
                            Poškozený
                        </span>
                        <span class="arrow-opened float-right">
                            <vue-fontawesome icon="chevron-down" />
                        </span>
                        <span class="arrow-closed float-right">
                            <vue-fontawesome icon="chevron-right" />
                        </span>
                    </b-button>
                </b-card-header>
                <b-collapse id="reportDamagesAccordion" visible role="tabpanel">
                    <b-card-body class="damagedTypesCardContent">
                        <div class="row mb-4">
                            <div class="col-12">
                                <select class="form-control" id="damagedTypes" ref="damagedTypes" v-model="insuranceEventAssetObject.damagedTypeId">
                                    <option v-for="damagedType in damagedTypes" :value="damagedType.Id" :key="damagedType.Id">
                                        {{damagedType.Name}}
                                    </option>
                                </select>
                                <div v-if="damagedSubmitted && !insuranceEventAssetObject.damagedTypeId" class="invalid-feedback d-block">Pole není vyplněno</div>
                            </div>
                        </div>
                        <b-button variant="primary" class="float-right mb-3" @click="damagedNext()">Další</b-button>
                    </b-card-body>
                </b-collapse>
            </b-card>

            <!-- Údaje o škodné události -->
            <b-card no-body class="mb-1" v-show="insuranceEventAssetObject.reportDamageTypeId !== -1 && lessEventDataShow">
                <b-card-header header-tag="header" class="p-0" role="tab">
                    <b-button block v-b-toggle.dataOnTheLessEventAcordion class="comfortLiquidityAcordion">
                        <span class="float-left pl-2">
                            Údaje o škodné události
                        </span>
                        <span class="arrow-opened float-right">
                            <vue-fontawesome icon="chevron-down" />
                        </span>
                        <span class="arrow-closed float-right">
                            <vue-fontawesome icon="chevron-right" />
                        </span>
                    </b-button>
                </b-card-header>
                <b-collapse id="dataOnTheLessEventAcordion" visible>
                    <b-card-body class="placeOfOccurenceCardContent">
                        <h5><b-badge pill class="px-3 py-2 font-weight-normal">Údaje o škodné události</b-badge></h5>
                        <div class="row">
                            <div class="col-6">
                                <base-input type="text" label="Místo vzniku" id="placeOfOccurence" v-model="insuranceEventAssetObject.lessEventData.placeOfOccurence" />
                                <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.lessEventData.placeOfOccurence" class="invalid-feedback d-block">Pole není vyplněno</div>
                                
                                <div class="col-6 mt-4 pt-3">
                                    <input class="ml-2 mr-2" type="checkbox" id="dontKnow" v-model="sameWithSubject" @change="sameWithSubjectChange()" />
                                    <label for="dontKnow">
                                        Shodné s adresou poškozeného
                                    </label>
                                </div>
                            </div>
                            
                            <div class="col-6">
                                <label for="damageDate">Datum a čas vzniku škody</label>
                                <datetime class="form-control" id="damageDate" type="datetime" title="Datum" v-model="insuranceEventAssetObject.lessEventData.dateAndTime" />
                                <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.lessEventData.dateAndTime" class="invalid-feedback d-block">Pole není vyplněno</div>
                                <div class="col-12 mt-4 pt-3">
                                    <input class="ml-2 mr-2" type="checkbox" id="dontKnow" v-model="insuranceEventAssetObject.lessEventData.dateAndTimeDontKnow" />
                                    <label for="dontKnow">
                                        Neznám datum vzniku, uvádím datum zjištění události.
                                    </label>
                                    <div v-if="lessEventDataSubmitted && insuranceEventAssetObject.lessEventData.dateAndTimeDontKnow == null" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Popis vzniku škody</label>
                                    <textarea rows="5" class="form-control border-input" v-model="insuranceEventAssetObject.lessEventData.description" />
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.lessEventData.description" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                            </div>                            
                        </div>
                        
                        <div class="row">
                            <div class="col-6">
                                <base-input type="text" label="Odhadovaná výše škody" v-model="insuranceEventAssetObject.lessEventData.estimatedAmountOfDamage" />
                                <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.lessEventData.estimatedAmountOfDamage" class="invalid-feedback d-block">Pole není vyplněno</div>
                            </div>
                            <div class="col-4">
                                <base-input type="text" label="Číslo šetření" class="mb-1" v-model="insuranceEventAssetObject.lessEventData.surveyNumber">
                                    <template slot="afterLabel">
                                        <i id="investigationNumber" class="fa fa-question-circle ml-2" aria-hidden="true">
                                            <b-tooltip target="investigationNumber" triggers="hover click">
                                                Pokud byla událost šetřena policií/hasiči, vyplňte prosím číslo hlášení a přiložte jej jako přílohu. V případě, že číslo nemáte, zaškrtněte „Neznám“
                                            </b-tooltip>
                                        </i>
                                    </template>
                                </base-input>
                                <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.lessEventData.surveyNumber" class="invalid-feedback d-block">Pole není vyplněno</div>
                            </div>
                            <div class="col-2 mt-4 pt-3">
                                <input class="ml-2 mr-2" type="checkbox" id="dontKnow" v-model="insuranceEventAssetObject.lessEventData.surveyNumberDontKnow" />
                                <label for="dontKnow">
                                    Neznám
                                </label>
                                <div v-if="lessEventDataSubmitted && insuranceEventAssetObject.lessEventData.surveyNumberDontKnow == null" class="invalid-feedback d-block">Pole není vyplněno</div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-6 mt-4 pt-3">
                                <input class="ml-2 mr-2" type="checkbox" id="eventSolved" v-model="insuranceEventAssetObject.lessEventData.eventWasSolved" />
                                <label for="eventSolved">
                                Byla událost řešena hasiči/policií
                                </label>
                                <div v-if="lessEventDataSubmitted && insuranceEventAssetObject.lessEventData.eventWasSolved == null" class="invalid-feedback d-block">Pole není vyplněno</div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Soupis poškozených věcí</label>
                                    <textarea rows="5" class="form-control border-input" v-model="insuranceEventAssetObject.lessEventData.damagedItems" />
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.lessEventData.damagedItems" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <input type="radio" id="naturalEvent" class="mr-2" :value="1" v-model="insuranceEventAssetObject.lessEventData.category">
                            <label for="naturalEvent">Živelní událost</label>
                            <i id="noticeHint" class="fa fa-question-circle ml-2" aria-hidden="true" 
                                v-b-tooltip.hover title="Požár, Výbuch, Blesk, Vichřice, Pád stromů a stožárů, Krupobití, Náraz vozidla, Tíha sněhu, Povodeň, Zemětřesení, Atmosferické srážky">
                            </i>
                        </div>

                        <div>
                            <input type="radio" id="water" class="mr-2" :value="2" v-model="insuranceEventAssetObject.lessEventData.category">
                            <label for="water">Vodovodní škody, únik vody</label>
                        </div>

                        <div>
                            <input type="radio" id="overvoltage" class="mr-2" :value="3" v-model="insuranceEventAssetObject.lessEventData.category">
                            <label for="overvoltage">Škoda vzniklá přepětím</label></label>
                        </div>

                        <div>
                            <input type="radio" id="theft" class="mr-2" :value="4" v-model="insuranceEventAssetObject.lessEventData.category">
                            <label for="theft">Škoda vzniklá odcizením</label>
                        </div>

                        <div>
                            <input type="radio" id="others" class="mr-2" :value="5" v-model="insuranceEventAssetObject.lessEventData.category">
                            <label for="others">Ostatní</label>
                        </div>

                        <div class="row" v-show="insuranceEventAssetObject.lessEventData.category === 5">
                            <div class="col-12">
                                <div class="form-group">
                                    <textarea rows="5" class="form-control border-input" v-model="insuranceEventAssetObject.lessEventData.categoryOthers" />
                                </div>
                            </div>
                        </div>


                        <div class="col-6 mt-4 pt-3">
                            <input class="ml-2 mr-2" type="checkbox" id="whitnessesOfTheEvent" v-model="insuranceEventAssetObject.lessEventData.whitnessesOfTheEvent" />
                            <label for="whitnessesOfTheEvent">
                                Svědci události
                            </label>
                        </div>

                        <div class="row" v-show="insuranceEventAssetObject.lessEventData.whitnessesOfTheEvent">
                            <div class="col-12 mb-3">
                            <div class="panel panel-primary" id="result_panel">
                                <div class="panel-heading justify-content-between d-flex">
                                    <b-button v-b-modal.modal-center variant="success" class="tableButtons" style="width: 130px !important;"><i class="fa fa-plus"></i>Přidat svědka</b-button>
                                    <b-modal id="modal-center" centered title="Přidat svědka" @ok="addWhitnessToList()">
                                        <base-input type="text" label="Jméno a příjmení" v-model="localWhitnessNameSurname" />
                                        <base-input type="text" label="Telefon" v-model="localWhitnessPhone" />
                                        <base-input type="text" label="Email" v-model="localWhitnessEmail" />
                                    </b-modal>
                                </div>

                                <div class="panel-body mt-3">
                                    <ul class="list-group">
                                    <li class="list-group-item" v-for="whitness in insuranceEventAssetObject.lessEventData.whitnesses" :value="whitness.id" :key="whitness.id">
                                        <b-button class="btn btn-danger btn-sm mr-3" @click="removeWhitness(whitness.id)"><i class="fa fa-remove"></i></b-button>
                                        <span>{{whitness.nameSurname + ', ' + whitness.phone + ', ' + whitness.email}}</span>
                                    </li>
                                    </ul>
                                </div>
                            </div>
                            </div>
                        </div>

                        <hr v-show="insuranceEventAssetObject.reportDamageTypeId === 2 || (insuranceEventAssetObject.reportDamageTypeId === 3 && insuranceEventAssetObject.otherAuthorizedPersonTypeId !== -1)">
                        <!-- Makléř/Agent or Jiná pověřená osoba -->
                        <div v-show="insuranceEventAssetObject.reportDamageTypeId === 2 || (insuranceEventAssetObject.reportDamageTypeId === 3 && insuranceEventAssetObject.otherAuthorizedPersonTypeId !== -1)">
                            <h5><b-badge pill class="px-3 py-2 font-weight-normal">Makléř/Agent</b-badge></h5>
                            <div class="row" v-show="insuranceEventAssetObject.reportDamageTypeId === 2 || insuranceEventAssetObject.otherAuthorizedPersonTypeId === 2">
                                <div class="col-xl-6 col-lg-12">
                                    <base-input type="text" label="Firma" v-model="insuranceEventAssetObject.agentData.companyName" />
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.agentData.companyName" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                                <div class="col-xl-4 col-lg-8 pr-0">
                                    <base-input type="text" label="IČ" class="mb-1" v-model="insuranceEventAssetObject.agentData.companyIc" />
                                    <label class="hint">Po vyplnění pole IČ a kliknutí na „Načíst“ se automaticky vyplní ostatní údaje z ARES</label>
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.agentData.companyIc" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                                <div class="col-xl-2 col-lg-4 mt-1 pl-0">
                                    <b-button class="mt-4 px-4" variant="primary" @click="getAresData()">Načíst</b-button>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <base-input type="text" label="Jméno a příjmení" v-model="insuranceEventAssetObject.agentData.userName" />
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.agentData.userName" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                                <div class="col-6">
                                    <base-input type="text" :label="insuranceEventAssetObject.reportDamageTypeId === 3 && insuranceEventAssetObject.otherAuthorizedPersonTypeId === 2 ? 'Sídlo' : 'Adresa'" 
                                        v-model="insuranceEventAssetObject.agentData.address" />
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.agentData.address" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <base-input type="text" label="Email hlásícího" v-model="insuranceEventAssetObject.agentData.email" />
                                    <!-- && !insuranceEventAssetObject.agentData.email -->
                                    <div v-if="lessEventDataSubmitted && !agentEmailValid" class="invalid-feedback d-block">Špatně vyplněný email</div>
                                </div>
                                <div class="col-6">
                                    <base-input type="text" label="Telefon hlásícího" v-model="insuranceEventAssetObject.agentData.phone" />
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.agentData.phone" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                            </div>
                        </div>

                        <hr v-show="insuranceEventAssetObject.damagedTypeId === 1">

                        <!-- Fyzická osoba -->
                        <div v-show="insuranceEventAssetObject.damagedTypeId === 1">
                            <h5><b-badge pill class="px-3 py-2 font-weight-normal">Fyzická osoba</b-badge></h5>
                            <div class="row">
                                <div class="col-6">
                                    <base-input type="text" label="Jméno a příjmení" v-model="insuranceEventAssetObject.insuranceSubject.userName" />
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.insuranceSubject.userName" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                                <div class="col-6">
                                    <base-input type="text" label="Adresa" v-model="insuranceEventAssetObject.insuranceSubject.address" />
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.insuranceSubject.address" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <base-input type="text" label="Telefon hlásícího" v-model="insuranceEventAssetObject.insuranceSubject.phone" />
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.insuranceSubject.phone" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                                <div class="col-6">
                                    <base-input type="text" label="Email hlásícího" v-model="insuranceEventAssetObject.insuranceSubject.email" />
                                    <div v-if="lessEventDataSubmitted && !insuranceSubjectEmailValid" class="invalid-feedback d-block">Špatně vyplněný email</div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <base-input type="text" label="Číslo pojistné smlouvy" v-model="insuranceEventAssetObject.insuranceSubject.insuranceContractNumber">
                                        <template slot="afterLabel">
                                            <i id="insuranceNumber" class="fa fa-question-circle ml-2" aria-hidden="true">
                                                <b-tooltip target="insuranceNumber" custom-class="insuranceNumberTooltip" triggers="hover click">
                                                    Číslo pojistné smlouvy
                                                </b-tooltip>
                                            </i>
                                        </template>
                                    </base-input>
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.insuranceSubject.insuranceContractNumber" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>

                                <div class="col-6">
                                    <label for="insuranceCompany">Pojišťovna</label>
                                    <select class="form-control" id="insuranceCompany" v-model="insuranceEventAssetObject.insuranceSubject.insuraceCompanyId">
                                        <option v-for="insuranceCompany in insuranceCompanies" :value="insuranceCompany.Id" :key="insuranceCompany.Id">
                                            {{insuranceCompany.Name}}
                                        </option>
                                    </select>
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.insuranceSubject.insuraceCompanyId" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <base-input type="text" label="Číslo škodní události" class="mb-1" v-model="insuranceEventAssetObject.insuranceSubject.lessEventNumber" />
                                    <label class="hint">Pokud byla událost hlášena na pojišťovnu, vyplňte prosím číslo škodní události</label>
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.insuranceSubject.lessEventNumber" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>

                                <div class="col-6">
                                    <base-input type="text" label="Pojistné plnění" class="mb-1" v-model="insuranceEventAssetObject.insuranceSubject.insuranceIndemnity.name" />
                                    
                                    <div class="row">
                                        <div class="col-2">
                                            <div class="row pl-2 mt-3">
                                                <input class="ml-2 mr-2" type="checkbox" id="invoice" v-model="insuranceEventAssetObject.insuranceSubject.insuranceIndemnity.invoice" />
                                                <label for="invoice">
                                                    Faktura
                                                </label>
                                            </div>

                                            <div class="row pl-2">
                                                <input class="ml-2 mr-2" type="checkbox" id="credit" v-model="insuranceEventAssetObject.insuranceSubject.insuranceIndemnity.credit" />
                                                <label for="credit">
                                                    Zápočet
                                                </label>
                                            </div>
                                        </div>

                                        <div class="col" v-show="insuranceEventAssetObject.insuranceSubject.insuranceIndemnity.invoice || insuranceEventAssetObject.insuranceSubject.insuranceIndemnity.credit">
                                            <div class="row">
                                                <div class="col-6">
                                                    <base-input type="text" label="" class="mb-0 pb-0 mt-3" v-model="insuranceEventAssetObject.insuranceSubject.insuranceIndemnity.bankAccount" />
                                                    <label class="hint">Bankovní účet</label>
                                                </div>

                                                <div class="col pl-2 mt-4">
                                                    <input class="ml-2 mr-2" type="checkbox" id="accountLater" v-model="insuranceEventAssetObject.insuranceSubject.insuranceIndemnity.accountLater" />
                                                    <label for="accountLater">
                                                        Účet dodám později
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr v-show="insuranceEventAssetObject.damagedTypeId === 2">

                        <!-- Firma -->
                        <div v-show="insuranceEventAssetObject.damagedTypeId === 2">
                            <h5><b-badge pill class="px-3 py-2 font-weight-normal">Firma</b-badge></h5>
                            <div class="row">
                                <div class="col-xl-6 col-lg-12">
                                    <base-input type="text" label="Firma" v-model="insuranceEventAssetObject.insuranceSubject.companyName" />
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.insuranceSubject.companyName" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                                <div class="col-xl-4 col-lg-8 pr-0">
                                    <base-input type="text" label="IČ" class="mb-1" v-model="insuranceEventAssetObject.insuranceSubject.companyIc" />
                                    <label class="hint">Po vyplnění pole IČ a kliknutí na „Načíst“ se automaticky vyplní ostatní údaje z ARES</label>
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.insuranceSubject.companyIc" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                                <div class="col-xl-2 col-lg-4 mt-1 pl-0">
                                    <b-button class="mt-4 px-4" variant="primary" @click="getAresData()">Načíst</b-button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <base-input type="text" label="Jméno a příjmení" />
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.insuranceSubject.userName" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                                <div class="col-6">
                                    <base-input type="text" label="Sídlo" v-model="insuranceEventAssetObject.insuranceSubject.address" />
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.insuranceSubject.address" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <base-input type="text" label="Email hlásícího" />
                                    <div v-if="lessEventDataSubmitted && !insuranceSubjectEmailValid" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                                <div class="col-6">
                                    <base-input type="text" label="Telefon hlásícího" />
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.insuranceSubject.phone" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <input class="ml-2 mr-2" type="checkbox" id="payerOfVat" />
                                    <label for="payerOfVat">
                                        Plátce DPH
                                    </label>
                                    <div v-if="lessEventDataSubmitted && !insuranceEventAssetObject.insuranceSubject.payerOfVat" class="invalid-feedback d-block">Pole není vyplněno</div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <base-input type="text" label="Pojistné plnění" class="mb-1" insuranceEventAssetObject.insuranceSubject.insuranceIndemnity.name />
                                    
                                    <div class="row">
                                        <div class="col-2">
                                            <div class="row pl-2 mt-3">
                                                <input class="ml-2 mr-2" type="checkbox" id="invoice" insuranceEventAssetObject.insuranceSubject.insuranceIndemnity.invoice />
                                                <label for="invoice">
                                                    Faktura
                                                </label>
                                            </div>

                                            <div class="row pl-2">
                                                <input class="ml-2 mr-2" type="checkbox" id="credit" insuranceEventAssetObject.insuranceSubject.insuranceIndemnity.credit />
                                                <label for="credit">
                                                    Zápočet
                                                </label>
                                            </div>
                                        </div>

                                        <div class="col" v-show="insuranceEventAssetObject.insuranceSubject.insuranceIndemnity.invoice || insuranceEventAssetObject.insuranceSubject.insuranceIndemnity.credit">
                                            <div class="row">
                                                <div class="col-6">
                                                    <base-input type="text" label="" class="mb-0 pb-0 mt-3" insuranceEventAssetObject.insuranceSubject.insuranceIndemnity.bankAccount />
                                                    <label class="hint">Bankovní účet</label>
                                                </div>

                                                <div class="col pl-2 mt-4">
                                                    <input class="ml-2 mr-2" type="checkbox" id="accountLater" insuranceEventAssetObject.insuranceSubject.insuranceIndemnity.accountLater />
                                                    <label for="accountLater">
                                                        Účet dodám později
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr>
                        <b-button variant="primary" class="float-right mb-3" @click="lessEventDataNext()">Další</b-button>
                    </b-card-body>
                </b-collapse>
            </b-card>

            <!-- Dokumenty a poznámky -->
            <b-card no-body class="mb-1" v-show="insuranceEventAssetObject.damagedTypeId !== -1 && documentsShow">
                <b-card-header header-tag="header" class="p-0" role="tab">
                    <b-button block v-b-toggle.documentsAcordion class="comfortLiquidityAcordion">
                        <span class="float-left pl-2">
                            Dokumenty a poznámky
                        </span>
                        <span class="arrow-opened float-right">
                            <vue-fontawesome icon="chevron-down" />
                        </span>
                        <span class="arrow-closed float-right">
                            <vue-fontawesome icon="chevron-right" />
                        </span>
                    </b-button>
                </b-card-header>
                <b-collapse id="documentsAcordion" role="tabpanel" visible>
                    <b-card-body>
                        <div class="row">
                            <div class="col-12 mb-3">
                                <label class="mb-3">Zde můžete nahrát více dokumentů najednou</label>
                                <b-form-file v-model="selectedFile" :state="Boolean(selectedFile)" placeholder="Vyberte nebo přetáhněte soubor..." @input="addFileToList()"
                                    drop-placeholder="Přetáhnout sem..." accept=".pdf,.csv"></b-form-file>
                                <div class="panel panel-primary" id="result_panel">
                                    <div class="panel-body mt-3">
                                        <ul class="list-group">
                                        <li class="list-group-item" v-for="document in documents" :value="document.Id" :key="document.id">
                                            <b-button class="btn btn-danger btn-sm mr-3" @click="removeDocument(document.Id)"><i class="fa fa-remove"></i></b-button>
                                            <span>{{document.Name}}</span>
                                        </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Poznámka</label>
                                    <i id="noticeHint" class="fa fa-question-circle ml-2" aria-hidden="true" 
                                        v-b-tooltip.hover title="Zde prosím doplňte jakkékoliv dodatečné informace, které si nám přejete k události sdělit. Tyto poznámky budou určeny pouze pro interní účely.">
                                    </i>
                                    <textarea rows="5" class="form-control border-input">
                                    </textarea>
                                </div>
                            </div>
                        </div>

                        <hr>
                        <b-button variant="success" class="float-right mb-3">Uložit</b-button>
                    </b-card-body>
                </b-collapse>
            </b-card>
          <div class="clearfix"></div>
        </form>
      </card>
    </div>
    <div id="snackbar">{{msg}}</div>
  </div>
</template>

<script>
  import Card from '@/components/Cards/Card.vue'
  import dataService from '@/services/dataService.js'
  import vueFormHelper from '@/js/VueFormHelper.js'
  import JQuery from 'jquery'
  import { Datetime } from 'vue-datetime'

  let $ = JQuery
  const VALIDATION_TYPE = Object.freeze({ REPORT_DAMAGE: 1, DAMAGED: 2, LESS_EVENT_DATA: 3 });

  export default {
    components: {
      Card,
      datetime: Datetime
    },
    methods: {
      async saveData() {
        this.submitted = true;
        this.validate();
        this.$router.push('/overview');
      },
      validate(validationType) {
          switch (validationType) {
              case VALIDATION_TYPE.REPORT_DAMAGE:
                if (!this.insuranceEventAssetObject.reportDamageTypeId) {
                    return false
                } else {
                    if ((this.insuranceEventAssetObject.reportDamageTypeId === 3) && !this.insuranceEventAssetObject.otherAuthorizedPersonTypeId)
                        return false
                }
                return true
              case VALIDATION_TYPE.DAMAGED:
                if (!this.insuranceEventAssetObject.damagedTypeId) {
                    return false
                }
                return true
              case VALIDATION_TYPE.LESS_EVENT_DATA:
                  // Makléř/Agent or Jiná pověřená osoba
                  if (this.insuranceEventAssetObject.reportDamageTypeId === 2 || (this.insuranceEventAssetObject.reportDamageTypeId === 3 && 
                      this.insuranceEventAssetObject.otherAuthorizedPersonTypeId !== -1)) {
                          if (!this.insuranceEventAssetObject.agentData.companyName || !this.insuranceEventAssetObject.agentData.companyIc ||
                              !this.insuranceEventAssetObject.agentData.userName || !this.insuranceEventAssetObject.agentData.address ||
                              !this.insuranceEventAssetObject.agentData.email || !this.insuranceEventAssetObject.agentData.phone ||
                              !this.validateEmail(this.insuranceEventAssetObject.agentData.email)) {
                                  this.agentEmailValid = this.validateEmail(this.insuranceEventAssetObject.agentData.email)
                                  return false
                              }

                        this.agentEmailValid = true
                  // Fyzická osoba
                  } else if (this.insuranceEventAssetObject.damagedTypeId === 1) {
                      if (!this.insuranceEventAssetObject.insuranceSubject.userName || !this.insuranceEventAssetObject.insuranceSubject.address ||
                          !this.insuranceEventAssetObject.insuranceSubject.phone || !this.insuranceEventAssetObject.insuranceSubject.email ||
                          !this.insuranceEventAssetObject.insuranceSubject.insuranceContractNumber || !this.insuranceEventAssetObject.insuranceSubject.insuraceCompanyId ||
                          !this.insuranceEventAssetObject.insuranceSubject.lessEventNumber || !this.validateEmail(this.insuranceEventAssetObject.insuranceSubject.email)) {
                              this.insuranceSubjectEmailValid = this.validateEmail(this.insuranceEventAssetObject.insuranceSubject.email)
                              return false
                          }
                      this.insuranceSubjectEmailValid = true
                  // Firma
                  } else if (this.insuranceEventAssetObject.damagedTypeId === 2) {
                      if (!this.insuranceEventAssetObject.insuranceSubject.companyName || !this.insuranceEventAssetObject.insuranceSubject.companyIc ||
                          !this.insuranceEventAssetObject.insuranceSubject.userName || !this.insuranceEventAssetObject.insuranceSubject.address ||
                          !this.insuranceEventAssetObject.insuranceSubject.email || !this.insuranceEventAssetObject.insuranceSubject.phone ||
                          !this.insuranceEventAssetObject.insuranceSubject.payerOfVat || !this.validateEmail(this.insuranceEventAssetObject.insuranceSubject.email)) {
                              this.insuranceSubjectEmailValid = this.validateEmail(this.insuranceEventAssetObject.insuranceSubject.email)
                              return false
                          }

                      this.insuranceSubjectEmailValid = true
                  }

                  // Údaje o škodné události
                  if (!this.insuranceEventAssetObject.lessEventData.placeOfOccurence ||
                      !this.insuranceEventAssetObject.lessEventData.description || !this.insuranceEventAssetObject.lessEventData.estimatedAmountOfDamage ||
                      !this.insuranceEventAssetObject.lessEventData.estimatedAmountOfDamage || !this.insuranceEventAssetObject.lessEventData.surveyNumber ||
                      this.insuranceEventAssetObject.lessEventData.surveyNumberDontKnow == null || this.insuranceEventAssetObject.lessEventData.eventWasSolved == null ||
                      !this.insuranceEventAssetObject.lessEventData.estimatedAmountOfDamage.damagedItems) {
                          return false
                  }

                  return true
              default:
                return true
          }
      },
      reportDamageNext() {
        this.reportDamageSubmitted = true
        if (!this.validate(VALIDATION_TYPE.REPORT_DAMAGE))
            return
        this.damagedShow = true
        this.$nextTick(() => {
            this.$refs.damagedTypes.focus()
        })
        $('.reportDamagesCardContent *').prop('disabled', true);
      },
      damagedNext() {
        this.damagedSubmitted = true
        if (!this.validate(VALIDATION_TYPE.DAMAGED))
            return
        this.lessEventDataShow = true
        $('.damagedTypesCardContent *').prop('disabled', true);
      },
      lessEventDataNext() {
          this.lessEventDataSubmitted = true
          if (!this.validate(VALIDATION_TYPE.LESS_EVENT_DATA))
            return
          this.documentsShow = true
          $('.placeOfOccurenceCardContent *').prop('disabled', true);
      },
      reportDamageChange() {
        if ((this.insuranceEventAssetObject.reportDamageTypeId === 2) || (this.insuranceEventAssetObject.reportDamageTypeId === 3))  {
            this.reportDamageContact = this.reportDamages[this.insuranceEventAssetObject.reportDamageTypeId-1].Name;
        }
      },
      removeDocument(documentId) {
        let index = this.documents.map(function(e) { return e.Id; }).indexOf(documentId);
        if (index > -1)
          this.documents.splice(index, 1);
      },
      async getAresData() {
        if ((this.insuranceEventAssetObject.insuranceSubject.companyIc === undefined) || (this.insuranceEventAssetObject.insuranceSubject.companyIc.length !== 8)) {
            vueFormHelper.showSnackbarMessage(this, 'Není vyplněno IČ nebo má špatný formát.', document);
        } else {
            let subject = await JSON.parse(await dataService.getAresSubjectByIc(this.insuranceEventAssetObject.insuranceSubject.companyIc));
            let item = subject['are:Ares_odpovedi']['are:Odpoved']['are:Zaznam'];
            if (item === undefined)
                return;
            this.insuranceEventAssetObject.insuranceSubject.companyName = item['are:Obchodni_firma']._text;
            let address = item['are:Identifikace']['are:Adresa_ARES'];
            this.insuranceEventAssetObject.insuranceSubject.address = address['dtt:Nazev_ulice']._text + ' ' + address['dtt:Cislo_domovni']._text + ', '  +
                address['dtt:PSC']._text + ' ' + address['dtt:Nazev_obce']._text;
        }
      },
      async addFileToList() {
          if (this.selectedFile !== null)
            this.documents.push({Name: this.selectedFile.name});
      },
      validateEmail(email) {
          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(String(email).toLowerCase());
      },
      sameWithSubjectChange() {
          if (this.sameWithSubject) {
            this.insuranceEventAssetObject.lessEventData.placeOfOccurence = this.insuranceEventAssetObject.insuranceSubject.address
          }
      },
      addWhitnessToList() {
        let roleName = $("#roleSelect option:selected").text();
        this.localWhitnessId = 123;
        let index = this.insuranceEventAssetObject.lessEventData.whitnesses.map(function(e) { return e.id; }).indexOf(this.localWhitnessId);

        if (index == -1)
          this.insuranceEventAssetObject.lessEventData.whitnesses.push({id: this.localWhitnessId, nameSurname: this.localWhitnessNameSurname, phone: this.localWhitnessPhone, email: this.localWhitnessEmail});
      },
      removeWhitness(whitnessId) {
        let index = this.insuranceEventAssetObject.lessEventData.whitnesses.map(function(e) { return e.Id; }).indexOf(whitnessId);
        if (index > -1)
          this.insuranceEventAssetObject.lessEventData.whitnesses.splice(index, 1);
      }
    },
    mounted: async function () {
      this.userRoles = JSON.parse(await dataService.getAllUserRoles(['Id', 'Name']));
      this.reportDamages = JSON.parse(await dataService.getAllReportDamageTypes());
      this.damagedTypes = JSON.parse(await dataService.getAllDamagedTypes());
      this.otherPersonTypes = JSON.parse(await dataService.getOtherAuthorizedPersonTypes());
      this.insuranceCompanies = JSON.parse(await dataService.getInsuranceCompanies());
      this.dataLoaded = true;
    },
    data () {
      return {
        msg: '',
        dataLoaded: false,
        submitted: false,
        reportDamageSubmitted: false,
        damagedSubmitted: false,
        lessEventDataSubmitted: false,
        agentEmailValid: false,
        insuranceSubjectEmailValid: false,
        newForm: true,
        reportDamageContact: "",
        reportDamages: [],
        damagedShow: false,
        damagedTypes: [],
        otherPersonTypes: [],
        insuranceCompanies: [],
        documents: [],
        selectedFile: null,
        lessEventDataShow: false,
        documentsShow: false,
        sameWithSubject: false,
        whitnessesOfTheEvent: false,
        localWhitnessId: null,
        localWhitnessNameSurname: null,
        localWhitnessPhone: null,
        localWhitnessEmail: null,
        insuranceEventAssetObject: {
          id: -1,
          reportDamageTypeId: null,
          otherAuthorizedPersonTypeId: null,
          damagedTypeId: null,
          otherAuthorizdPersonTypeId: null,
          lessEventNumber: null,
          insuranceSubject: {
              id: -1,
              userName: null,
              address: null,
              email: null,
              phone: null,
              companyName: null,
              companyIc: null,
              companyRegisteredOffice: null,
              insuraceCompanyId: null,
              insuranceContractNumber: null,
              payerOfVat: false,
              insuranceIndemnity: {
                id: -1,
                name: null,
                invoice: false,
                credit: false,
                bankAccount: null,
                accountLater: false,
              }
          },
          lessEventData: {
              id: -1,
              placeOfOccurence: null,
              dateAndTime: null,
              dateAndTimeDontKnow: false,
              description: null,
              estimatedAmountofDamage: null,
              eventWasSolved: false,
              surveyNumber: null,
              surveyNumberDontKnow: false,
              damagedItems: null,
              category: null,
              categoryText: null,
              whitnessesOfTheEvent: false,
              whitnesses: []
          },
          agentData: {
              id: -1,
              companyName: null,
              companyIc: null,
              userName: null,
              address: null,
              email: null,
              phone: null
          },
        }
      }
    }
  }
</script>

<style scoped>
.list-group {
  max-height: 300px;
  min-height: 100px;
  margin-bottom: 10px;
  overflow:scroll;
  -webkit-overflow-scrolling: touch;
}

.tooltip .tooltip-inner {
  max-width: 500px !important;
  width: 400px !important;
}

.insuranceNumberTooltip .tooltip-inner {
  max-width: 300px !important;
  width: 200px !important;
}

.collapsed > .arrow-opened,
  :not(.collapsed) > .arrow-closed {
  display: none;
}
</style>